<div class="gallery-container">
  <!-- Section Title -->
  <h2 class="page-title">Our Gallery</h2>


  <!-- Video Slider -->
  <div class="video-slider">
    <div class="slider-container">
      <div class="slider-track">
        <div class="slider-page" *ngFor="let i of slidesArray; let pageIndex = index"
          [style.transform]="'translateX(' + (pageIndex - currentSlide) * 100 + '%)'"
          [style.visibility]="Math.abs(pageIndex - currentSlide) <= 1 ? 'visible' : 'hidden'">
          <div class="video-item" *ngFor="let item of getPageItems(pageIndex); let itemIndex = index">
            <div class="video-thumbnail" (click)="openVideo(videoModal, item)">
              <div class="thumbnail-wrapper">
                <img [src]="item.thumbnailUrl" [alt]="item.title" loading="lazy">
                <div class="play-overlay">
                  <div class="play-button">
                    <i class="fas fa-play"></i>
                  </div>
                </div>
              </div>
              <div class="video-info">
                <h3>{{ item.title }}</h3>
                <div class="video-meta">
                  <span class="duration">
                    <i class="fas fa-clock"></i> Watch Now
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation Buttons -->
    <button class="nav-button prev" (click)="prevSlide()" [class.disabled]="!canShowPrevious">
      <div class="button-content">
        <i class="fas fa-chevron-left"></i>
      </div>
    </button>
    <button class="nav-button next" (click)="nextSlide()" [class.disabled]="!canShowNext">
      <div class="button-content">
        <i class="fas fa-chevron-right"></i>
      </div>
    </button>

    <!-- Progress Bar -->
    <div class="slider-progress">
      <div class="progress-bar" *ngFor="let _ of slidesArray; let i = index" [class.active]="i === currentSlide"
        (click)="currentSlide = i">
        <div class="progress-fill"></div>
      </div>
    </div>
  </div>
</div>

<!-- Video Modal Template -->
<ng-template #videoModal let-modal>
  <div class="video_modal">
    <div class="modal-header">
      <h4 class="modal-title">{{ selectedVideo?.title }}</h4>
      <button type="button" class="close-button" (click)="modal.dismiss()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="video-wrapper">
        <video *ngIf="selectedVideo" [src]="selectedVideo.videoUrl" controls autoplay class="modal-video">
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  </div>
</ng-template>